import React, { createContext, useContext, useState, useEffect } from 'react';
import en from '../translations/en'; // Файл с английскими переводами
import ru from '../translations/ru'; // Файл с русскими переводами

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Считываем язык из localStorage, если он есть, иначе устанавливаем 'ru'
    return localStorage.getItem('language') || 'ru';
  });

  const translations = language === 'en' ? en : ru; // Выбор перевода на основе языка

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang); // Сохраняем выбранный язык в localStorage
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage && storedLanguage !== language) {
      setLanguage(storedLanguage); // Обновляем состояние, если язык в localStorage изменился
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ translations, switchLanguage, language }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
